module.exports = __webpack_public_path__ + "img/arrow.ac6fe198.png";